<template>
    <div>
        <tab name="5">{{userName}}(ID:{{id}})</tab>
        <user-account :userId="id" :userType="2" :userName.sync="userName"></user-account>
    </div>
</template>

<script>
import Tab from './components/tab';
import UserAccount from '@/views/user/components/user-account';
export default {
    props:{
        id:{
            type:[Number,String],
            default: ''
        }
    },
    components:{
        Tab,UserAccount
    },
    data() {
        return {
            userName:''
        };
    }
}
</script>